import { render, staticRenderFns } from "./FaqDetail.vue?vue&type=template&id=450976c8&"
import script from "./FaqDetail.vue?vue&type=script&lang=js&"
export * from "./FaqDetail.vue?vue&type=script&lang=js&"
import style0 from "./FaqDetail.vue?vue&type=style&index=0&id=450976c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports